
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"height":"34","viewBox":"0 0 34 34","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M32.123 0H1.877C.84 0 0 .84 0 1.877v30.247C0 33.16.84 34 1.877 34H18.16V20.834h-4.43v-5.132h4.43v-3.784c0-4.392 2.683-6.783 6.6-6.783 1.877 0 3.49.14 3.96.202v4.59l-2.717.001c-2.131 0-2.544 1.012-2.544 2.498v3.276h5.082l-.662 5.131h-4.42V34h8.665C33.16 34 34 33.16 34 32.123V1.878C34 .84 33.16 0 32.123 0z","fill":"#000"}})])
          )
        }
      }
    